export default __webpack_public_path__ + "images/105d00ecfbdba8ced44b2c9001189059-golf_small.webp";